<template>
    <div v-if="user" class="w-full flex flex-column gap-3 mb-4" >
        <div class="w-full flex flex-column gap-2 relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
            <span class="flex gap-3 text-lg xl:text-xl text-900 font-medium">
                Пользователь: 
            </span>
            <span class="flex flex-column gap-2 text-sm xl:text-base text-600">
                <AvatarGroup v-if="user.photo" class="flex">
                    <Avatar :image="user.photo" shape="circle" size="large"/>
                </AvatarGroup>
                <span v-if="user.id" class="flex">ID: {{ user.id }}</span>
                <span v-if="user.ledger_id" class="flex">Ledger ID: {{ user.ledger_id }}</span>
                <span class="flex" :class="(user.verified) ? 'text-green-500' : ''">
                    Верификация: {{ (user.verified) ? 'Пройдена' : 'Не пройдена' }}
                </span>
                <span v-if="user.name" class="flex">Имя: {{ user.name }}</span>
                <span v-if="user.login" class="flex">Логин: {{ user.login }}</span>
                <span v-if="user.email" class="flex">Email: {{ user.email }}</span>
                <span v-if="user.groups" class="flex">Группы: {{ user.groups.join(', ') }}</span>

                <div v-if="user.phone && user.prefix" class="flex flex-row gap-2 align-items-center">
                    <span v-if="user.phone" class="flex">Телефон: {{ user.prefix }}{{ user.phone }}</span>
                    <Button @click="goToWhatsApp(user.prefix, user.phone)" severity="info" icon="pi pi-comments"  size="small" outlined />
                </div>
                <span v-else class="flex">Телефон: не указан</span>

                <div v-if="user.sendpulse && user.sendpulse.id" class="flex flex-row gap-2 align-items-center">
                    <span class="flex"> Sendpulse: {{ user.sendpulse.id }}</span>
                    <Button @click="goToSendpulse(user.sendpulse.id)" severity="info" icon="pi pi-comments"  size="small" outlined />
                </div>
                <span v-else class="flex">Sendpulse: не привязан</span>

                <div v-if="user.telegram" class="flex flex-row gap-2 align-items-center">
                    <span class="flex"> Telegram: {{ user.telegram }}</span>
                    <Button @click="goToTelegram(user.telegram)" severity="info" icon="pi pi-telegram"  size="small" outlined />
                </div>
                <span v-else class="flex">Telegram: не привязан</span>

                <div v-if="user.notion && user.notion.crm_id" class="flex flex-row gap-2 align-items-center">
                    <span class="flex"> Notion: {{ user.notion.crm_id }}</span>
                    <Button @click="goToNotion(user.notion.crm_id)" severity="info" icon="pi pi-external-link"  size="small" outlined />
                </div>
            </span>
            <div class="flex flex-row flex-wrap gap-2 lg:max-w-25rem">
                <Button label="Редактировать" icon="pi pi-pencil" iconPos="right" @click="editPopup=true" size="small" severity="info" 
                    :disabled="loading" class="w-full border-round-md md:flex-1"/>
                <Button v-if="isUserInGroup('admin')" label="Сбросить пароль" icon="pi pi-key" iconPos="right" @click="resetPasswordPopup=true" size="small" severity="info" outlined 
                    :disabled="loading || !user.id" class="w-full border-round-md md:flex-1"/>
            </div>
        </div>

        <MobMenu v-if="user && user.id" :items="[]" colorType="gray" class="w-full max-w-30rem">
            <template v-slot:body>
                <div class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.id, 'transfers')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Переводы</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div v-if="user.ledger_id" class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.ledger_id, 'wallets')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Кошельки</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.id, 'files')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Файлы</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.id, 'senders')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Отправители</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.id, 'recipients')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Получатели</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div v-if="user.ledger_id" class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.ledger_id, 'vcards')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Виртуальные карты</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-0 border-bottom-1 cursor-pointer" 
                    style="min-height:50px" @click="toDetail(user.id, 'partners')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">Партнер</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2 pi pi-angle-right" />
                    </div>
                </div>
            </template>
        </MobMenu>
    </div>
    <!--ИЗМЕНЕНИЕ-->
    <Dialog 
        header="Редактировать пользователя" class="flex flex-column border-none" modal
        v-model:visible="editPopup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >

        <div class="w-full flex flex-column mb-3">
            <span class="flex text-600 mb-2 text-sm">
                Верификация:
            </span>
            <SelectButton v-model="verified" :options="verifyList" optionLabel="name" optionValue="value" aria-labelledby="basic" />
        </div>
        
        <template #footer>
            <Button label="Закрыть"  @click="editPopup=false" autofocus severity="secondary" :disabled="loading" :loading="loading"/>
            <Button label="Сохранить" icon="pi pi-check" @click='UpdateUser()' :disabled="loading" :loading="loading" class="ml-2"/>
        </template>
    </Dialog>

    <!-- СБРОС ПАРОЛЯ -->
    <Dialog
        header="Сброс пароля" class="flex flex-column border-none" modal
        v-model:visible="resetPasswordPopup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >

        <div class="w-full flex flex-column mb-3">
            <span class="text-600 mb-2 text-sm">
                Пароль пользователя будет сброшен на <span class="font-medium text-900">123456</span>. Продолжить?
            </span>
        </div>

        <template #footer>
            <Button label="Закрыть" @click="resetPasswordPopup=false" autofocus severity="secondary" :disabled="loadingResetPassword" :loading="loadingResetPassword"/>
            <Button label="Сбросить" icon="pi pi-check" @click="resetPassword" :disabled="loadingResetPassword" :loading="loadingResetPassword" class="ml-2"/>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import MobMenu from '@/components/sides/menu/MobMenu.vue'

export default {
    name: 'UserDetail',
    props: {
        user: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            // user: null,
            loading: false,
            active: 0,
            recipients: null,
            loadingRecipients: false,
            totalRecipients: 0,
            currencies: [],
            editPopup: false,
            resetPasswordPopup: false,
            loadingResetPassword: false,
            verifyList: [
                { name: 'Не пройдена', value: false },
                { name: 'Пройдена', value: true }
            ],
            verified: null,
        }
    },
    components: {
        MobMenu
    },
    watch: {
        active: function (val) {
            // if(val==0) this.LoadRecipients(this.user_id)
        },
    },
    methods: {
        getShortId(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        getBankImage(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        getBankTitle(code){
            return this.helper.get_bank_title(code, this.$store.state.payment.banks, 'ru')
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        toDetail(id, type) {
            if(!id || id=='') return
            if(!type || type=='') return
            this.$router.push({path: `/admin/${type}/`, query: { user_id: id }})
        },
        goToTelegram(username){
            if(!username) return
            window.open('https://t.me/' + username, '_blank')
            return
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        goToNotion(id){
            if(!id) return
            if(typeof id !== 'string') return
            const str = id.replace(/-/g, '')
            window.open(`https://www.notion.so/pworigin/fe8e29f8f7d84859bb4ccdedb599ebdc?p=${str}`, '_blank')
        },
        goToSendpulse(id){
            if(!id) return
            window.open(`https://login.sendpulse.com/chatbots/chats?contact_id=${id}&channel=telegram`, '_blank')
            return
        },
        goToWhatsApp(prefix, number){
            if(!number) return
            window.open('https://wa.me/' + prefix +number, '_blank')
            return
        },
        async UpdateUser(){
            if(!this.user || !this.user.id) return
            this.loading = true
            const data = {
                verified: this.verified
            }
            try {
                const res = await this.connect.UpdateUserByAdmin(this.user.id, data).then(res=>res)
                if(res.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Пользователь обновлен', life: 3000 })
                    this.editPopup = false
                    this.$emit('update')
                }
                else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.message, life: 3000 })
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
        async resetPassword() {
            if (!this.user || !this.user.id) return
            this.loadingResetPassword = true
            try {
                const res = await this.connect.UpdateUserByAdmin(this.user.id, { reset_password: true }).then(res=>res)
                if (res.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Пароль сброшен на 123456', life: 3000 })
                    this.resetPasswordPopup = false
                }
                else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.message, life: 3000 })
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingResetPassword = false
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
       
    }
}
</script>